export const MEDIA_ERR_NETWORK = 2;
export const MEDIA_ERR_SRC_NOT_SUPPORTED = 4;

export const READY_STATE_HAVE_NOTHING = 0;
export const READY_STATE_HAVE_METADATA = 1;
export const READY_STATE_HAVE_CURRENT_DATA = 2;
export const READY_STATE_HAVE_FUTURE_DATA = 3;
export const READY_STATE_HAVE_ENOUGH_DATA = 4;
